<template>

  <div class="builder" :class="{rtl : is_rtl}">

        <div class="locale-selector">
            <button type="button" class="lang-en" @click="updateLocale('en')" :class="{'activeLang' : this.current_lang == 'en'}">
                <img src="static/images/us.svg" alt="English">
            </button>
            <button type="button" class="lang-ru" @click="updateLocale('ru')" :class="{'activeLang' : this.current_lang == 'ru'}">
                <img src="static/images/ru.svg" alt="Russian">
            </button>
            <button type="button" class="lang-he" @click="updateLocale('he')" :class="{'activeLang' : this.current_lang == 'he'}">
                <img src="static/images/il.svg" alt="Hebrew">
            </button>
        </div>

        <div class="page-titles">
            <h1 class="page-title">{{ locale[current_lang].title }}</h1>
            <h2 class="page-sub-title"><span>{{ locale[current_lang].subtitle }}</span></h2>
        </div>

        <hr>

        <div class="step-header">
            <span>{{ locale[current_lang].step1_title }}</span>
        </div>

        <div class="builder-form-wrapper">

            <form class="builder-form" method="post" @submit.prevent>

                <div class="form-row is-user-id-row">
                    <h3><span>{{ locale[current_lang].user_settings }}:</span></h3>
                    <div v-if="!free_mode">
                        <label>
                            <span>{{ locale[current_lang].user_id }}:</span>
                            <input type="text" v-model="uid">
                        </label>
                    </div>
                </div>

                <div class="form-row is-theme_settings-row" v-if="!free_mode">
                    <h3><span>{{ locale[current_lang].theme_settings }}:</span></h3>
                    <label>
                        <span>{{ locale[current_lang].theme_name }}:</span>
                        <select v-model="json.theme.name">
                            <option value="dark">{{ locale[current_lang].dark_label }}</option>
                            <option value="light">{{ locale[current_lang].light_label }}</option>
                        </select>
                    </label>
                    <label>
                        <span>{{ locale[current_lang].layout }}:</span>
                        <select v-model="json.theme.type">
                            <option value="1">{{ locale[current_lang].standart_label }}</option>
                            <option value="2">{{ locale[current_lang].wide_label }}</option>
                            <option value="3">{{ locale[current_lang].magic_label }}</option>
							<option value="4">{{ locale[current_lang].modern_label }}</option>
                        </select>
                    </label>
                    <label>
                        <span>{{ locale[current_lang].sidebar_position }}:</span>
                        <select v-model="json.theme.position">
                            <option value="right">{{ locale[current_lang].right_label }}</option>
                            <option value="left">{{ locale[current_lang].left_label }}</option>
                        </select>
                    </label>
                </div>

                <div class="form-row is-setup_settings-row">
                    <h3><span>{{ locale[current_lang].setup_settings }}:</span></h3>

                    <label>
                        <span>{{ locale[current_lang].language }}:</span>
                        <select v-model="json.setup.lang" @change="updateLivePreviewLanguage()">
                            <option value="en">{{ locale[current_lang].english_label }}</option>
                            <option value="ru">{{ locale[current_lang].russian_label }}</option>
                            <option value="he">{{ locale[current_lang].hebrew_label }}</option>
                        </select>
                    </label>

                    <div class="setup_inputs_wrapper">

                        <label class="inline" v-if="json.theme.type==4">
                            <input type="checkbox" v-model="json.setup.show_icons">
                            <span v-html="locale[current_lang].show_icons_label"></span>
                        </label>
						<label class="inline" v-if="json.theme.type==4">
                            <input type="checkbox" v-model="json.setup.show_statement">
                            <span v-html="locale[current_lang].show_statement_label"></span>
                        </label>

                        <label class="inline">
                            <input type="checkbox" v-model="json.setup.jquery">
                            <span v-html="locale[current_lang].jquery"></span>
                        </label>

                        <div v-if="!free_mode">
                            <label v-if="json.theme.type!=4" class="inline">
                                <input type="checkbox" v-model="json.setup.debug">
                                <span>{{ locale[current_lang].enable_debug }}</span>
                            </label>

                            <label v-if="json.theme.type!=4" class="inline">
                                <input type="checkbox" v-model="json.setup.stats">
                                <span>{{ locale[current_lang].enable_statistics }}</span>
                            </label>

                            <label v-if="json.theme.type!=4" class="inline">
                                <input type="checkbox" v-model="json.setup.hide.remove_animations">
                                <span>{{ locale[current_lang].disable_remove_animations }}</span>
                            </label>

                            <label v-if="json.theme.type!=4" class="inline">
                                <input type="checkbox" v-model="json.setup.hide.highlight_titles">
                                <span>{{ locale[current_lang].disable_highlight_titles }}</span>
                            </label>

                            <label v-if="json.theme.type!=4" class="inline">
                                <input type="checkbox" v-model="json.setup.hide.highlight_links">
                                <span>{{ locale[current_lang].disable_highlight_links }}</span>
                            </label>

                            <label v-if="json.theme.type!=4" class="inline">
                                <input type="checkbox" v-model="json.setup.hide.keyboard_navigation">
                                <span>{{ locale[current_lang].disable_keyboard_navigations }}</span>
                            </label>

                            <label v-if="json.theme.type!=4" class="inline">
                                <input type="checkbox" v-model="json.setup.hide.invert_colors">
                                <span>{{ locale[current_lang].disable_invert_colors }}</span>
                            </label>

                            <label v-if="json.theme.type!=4" class="inline">
                                <input type="checkbox" v-model="json.setup.hide.readable_fonts">
                                <span>{{ locale[current_lang].disable_readable_fonts }}</span>
                            </label>
                        </div>

                    </div>

                </div>

            </form>

            <div class="builder-live" v-if="code">
                <h3><span>{{ locale[current_lang].live_preview_title }}:</span></h3>

                <div class="live-preview-bg-colors">
                    <button class="bg-button black" @click="switchLivePreviewBG('#000', '#FFF')"></button>
                    <button class="bg-button white" @click="switchLivePreviewBG('#FFF', '#000')"></button>
                    <button class="bg-button grey" @click="switchLivePreviewBG('#ddd', '#000')"></button>
					<button class="bg-button blue" @click="switchLivePreviewBG('blue', '#FFF')"></button>
                </div>

                <div class="builder-live-content" :style="{
                        'background' : defaultLivePreviewBG,
                        'color' : defaultLivePreviewColor
                    }">

                    <div class="builder-lorem" v-html="locale[current_lang].lorem_ipsum"></div>

                    <div id="wp_access_helper_container" v-if="this.json.theme.type != 4" class="accessability_container active"
                        :class="{
                            'dark_theme' : json.theme.name == 'dark',
                            'light_theme' : json.theme.name == 'light',
                            'accessibility-location-right' : json.theme.position == 'right',
                            'accessibility-location-left' : json.theme.position == 'left',
                            'wahpro-wide-sidebar' : json.theme.type == 2,
                            'wahpro-magic-sidebar' : json.theme.type == 3,
							'wahpro-wah-modern' : json.theme.type == 4,
                            'is-rtl' : json.setup.lang == 'he'
                            }"
                        >
                        <div id="access_container" aria-hidden="false">

                            <button type="button" class="close_container wahout">
                                {{ advancedSettings ? advanced.close : locale[current_live_lang].live.close }}
                            </button>

                            <div class="access_container_inner">

                                <div class="a_module wah_font_resize">
                                    <div class="a_module_title">
                                        {{ advancedSettings ? advanced.font_resize : locale[current_live_lang].live.font_resize }}
                                    </div>
                                    <div class="a_module_exe font_resizer">
                                        <button type="button" class="wah-action-button smaller wahout">
                                            {{ advancedSettings ? advanced.font_resize_sign : 'A' }}-
                                        </button>
                                        <button type="button" class="wah-action-button larger wahout">
                                            {{ advancedSettings ? advanced.font_resize_sign : 'A' }}+
                                        </button>
                                        <button type="button" class="wah-action-button wah-font-reset wahout">
                                            {{ advancedSettings ? advanced.reset_font_size : locale[current_live_lang].live.reset_font_size }}
                                        </button>
                                    </div>
                                </div>

                                <div class="a_module wah_keyboard_navigation" v-if="!json.setup.hide.keyboard_navigation">
                                    <div class="a_module_exe">
                                        <button type="button" class="wah-action-button wahout wah-call-keyboard-navigation">
                                            {{ advancedSettings ? advanced.keyboard_navigation : locale[current_live_lang].live.keyboard_navigation }}
                                        </button>
                                    </div>
                                </div>

                                <div class="a_module wah_readable_fonts" v-if="!json.setup.hide.readable_fonts">
                                    <div class="a_module_exe readable_fonts">
                                        <button type="button" class="wah-action-button wahout wah-call-readable-fonts">
                                            {{ advancedSettings ? advanced.readable_font :locale[current_live_lang].live.readable_font }}
                                        </button>
                                    </div>
                                </div>

                                <div class="a_module wah_contrast_trigger" v-if="!json.setup.hide.contrast">
                                    <div class="a_module_title">{{ locale[current_live_lang].live.contrast }}</div>
                                    <div class="a_module_exe">
                                        <button type="button" id="contrast_trigger" class="contrast_trigger wah-action-button wahout wah-call-contrast-trigger">
                                            {{ advancedSettings ? advanced.choose_color : locale[current_live_lang].live.choose_color }}
                                        </button>
                                    </div>
                                </div>

                                <div class="a_module wah_highlight_links" v-if="!json.setup.hide.highlight_links">
                                    <div class="a_module_exe">
                                        <button type="button" class="wah-action-button wahout wah-call-highlight-links">
                                            {{ advancedSettings ? advanced.highlight_links : locale[current_live_lang].live.highlight_links }}
                                        </button>
                                    </div>
                                </div>

                                <div class="a_module wah_highlight_titles" v-if="!json.setup.hide.highlight_titles">
                                    <div class="a_module_exe">
                                        <button type="button" class="wah-action-button wahout wah-call-highlight-titles">
                                            {{ advancedSettings ? advanced.highlight_titles : locale[current_live_lang].live.highlight_titles }}
                                        </button>
                                    </div>
                                </div>

                                <div class="a_module wah_clear_cookies">
                                    <div class="a_module_exe">
                                        <button type="button" class="wah-action-button wahout wah-call-clear-cookies">
                                            {{ advancedSettings ? advanced.clear_cookies : locale[current_live_lang].live.clear_cookies }}
                                        </button>
                                    </div>
                                </div>

                                <div class="a_module wah_greyscale">
                                    <div class="a_module_exe">
                                        <button type="button" id="greyscale" class="greyscale wah-action-button wahout wah-call-greyscale">
                                            {{ advancedSettings ? advanced.images_greyscale : locale[current_live_lang].live.images_greyscale }}
                                        </button>
                                    </div>
                                </div>

                                <div class="a_module wah_invert" v-if="!json.setup.hide.invert_colors">
                                    <div class="a_module_exe">
                                        <button type="button" class="wah-action-button wahout wah-call-invert">
                                            {{ advancedSettings ? advanced.invert_colors : locale[current_live_lang].live.invert_colors }}
                                        </button>
                                    </div>
                                </div>

                                <div class="a_module wah_remove_animations" v-if="!json.setup.hide.remove_animations">
                                    <div class="a_module_exe">
                                        <button type="button" accesskey="a" class="wah-action-button wahout wah-call-remove-animations">
                                            {{ advancedSettings ? advanced.remove_animations : locale[current_live_lang].live.remove_animations }}
                                        </button>
                                    </div>
                                </div>


                            </div>
                        </div>

                    </div>

					<aside id="wp_access_helper_container" v-if="this.json.theme.type == 4" class="accessability_container active"
						:class="{
                            'dark_theme' : json.theme.name == 'dark',
                            'light_theme' : json.theme.name == 'light',
                            'accessibility-location-right' : json.theme.position == 'right',
                            'accessibility-location-left' : json.theme.position == 'left',
                            'wahpro-wide-sidebar' : json.theme.type == 2,
                            'wahpro-magic-sidebar' : json.theme.type == 3,
							'wahpro-wah-modern' : json.theme.type == 4,
                            'is-rtl' : json.setup.lang == 'he'
                            }"
							>

						<button type="button" class="wahout aicon_link layout-wah-modern wah-is-active" accesskey="z" aria-label="Accessibility Helper sidebar" title="Accessibility Helper sidebar" style="font-size: 30px; border: 0px; padding: 0px; width: 50px; height: 50px; background-color: rgb(203, 35, 109) !important; display: inline-block;left: -49px;position: absolute;">
							<span class="goi-wah-icon wah-font-icon" style="font-size:30px;color:#ffffff !important;" data-wahfont="30"></span>
						</button>

						<div id="access_container" aria-hidden="false">

							<div class="wahpro-buttons-header">

								<button tabindex="0" type="button" class="close_container wahout" accesskey="x" aria-label="Close" title="Close">
									<span v-html="locale[current_lang].live.close"></span>
								</button>

								<button data-widgetid="widget-7" type="button" class="wah-action-button wahout wah-call-clear-cookies" aria-label="Reset Settings" title="Reset Settings" tabindex="0"
									:class="{
										'show_statement-off' : json.setup.show_statement==false
									}"
								>
									<span v-if="json.setup.show_icons==true" class="goi-icon goi-beveled-rows" aria-hidden="true"></span>
									<span v-html="locale[current_lang].live.clear_cookies"></span>
								</button>

								<button v-if="json.setup.show_statement==true" type="button" id="wahpro-accessibility-statement" class="wahout" aria-label="Statement" aria-haspopup="true" aria-expanded="false" tabindex="0">
									<span v-if="json.setup.show_icons==true" class="goi-info-b" aria-hidden="true"></span>
									<span v-html="locale[current_lang].live.statement"></span>
								</button>

							</div>

							<div class="access_container_inner" tabindex="1" style="overflow: hidden; outline: none;">

								<div class="wahpro-font-settings-wrapper">
									<div class="a_module wah_readable_fonts">
										<div class="a_module_exe readable_fonts">
											<button tabindex="0" data-widgetid="widget-3" type="button" class="wah-action-button wahout wah-call-readable-fonts" aria-label="Readable Font" title="Readable Font">
												<span class="goi-icon goi-letter-inside-black" v-if="json.setup.show_icons==true"></span>
												Readable Font
											</button>
										</div>
									</div>

									<div class="font-size-settings-inner">
										<div class="a_module wah_font_resize separate_small_font_size">
											<div class="a_module_exe font_resizer">
												<button tabindex="0" type="button" class="wah-action-button smaller wahout" title="smaller font size" aria-label="smaller font size">
													A-<span class="goi-icon goi-letter-a" v-if="json.setup.show_icons==true"></span>
												</button>
											</div>
										</div>
										<div class="a_module wah_font_resize separate_large_font_size">
											<div class="a_module_exe font_resizer">
												<button tabindex="0" type="button" class="wah-action-button larger wahout" title="larger font size" aria-label="larger font size">
													A+<span class="goi-icon goi-letter-a" v-if="json.setup.show_icons==true"></span>
												</button>
											</div>
										</div>
										<div class="a_module wah_font_resize separate_reset_font_size">
											<button tabindex="0" type="button" class="wah-action-button wah-font-reset wahout" title="Reset font size" aria-label="Reset font size">
												Reset font size<span class="goi-icon goi-refresh" v-if="json.setup.show_icons==true"></span>
											</button>
										</div>
									</div>

									<div class="font-alignment-settings-inner">
										<div class="a_module">
											<div class="a_module_exe">
												<label tabindex="0" data-widgetid="widget-23" type="button" id="wah_text_alignment_left" class="wah-action-button wah-uniqid wahout set-wah_text_alignment_left" aria-label="Align left" data-wahaction="align-left">
													<input type="checkbox" name="wah_text_alignment_left">
													<span class="wahpro-checkbox-indicator"></span>
													Align left<span class="goi-icon goi-align-left" v-if="json.setup.show_icons==true"></span>
												</label>
											</div>
										</div>
										<div class="a_module">
											<div class="a_module_exe">
												<label tabindex="0" data-widgetid="widget-23" type="button" id="wah_text_alignment_center" class="wah-action-button wah-uniqid wahout set-wah_text_alignment_center" aria-label="Align center" data-wahaction="align-center">
													<input type="checkbox" name="wah_text_alignment_center">
													<span class="wahpro-checkbox-indicator"></span>
													Align center
													<span class="goi-icon goi-align-center-hor" v-if="json.setup.show_icons==true"></span>
												</label>
											</div>
										</div>
										<div class="a_module">
											<div class="a_module_exe">
												<label tabindex="0" data-widgetid="widget-23" type="button" id="wah_text_alignment_right" class="wah-action-button wah-uniqid wahout set-wah_text_alignment_right" aria-label="Align right" data-wahaction="align-right">
													<input type="checkbox" name="wah_text_alignment_right">
													<span class="wahpro-checkbox-indicator"></span>
													Align right<span class="goi-icon goi-align-right" v-if="json.setup.show_icons==true"></span>
												</label>
											</div>
										</div>
									</div>
								</div>

								<div class="wahpro-modern-contrast-settings">
									<div class="a_module wah_contrast_trigger">
							 			<div class="a_module_exe contrast_module_exe">
							 				<label tabindex="0" data-widgetid="widget-4" id="contrast_trigger" class="contrast_trigger wah-action-button wahout wah-call-contrast-trigger" title="Adjust Background Colors">
												Adjust Background Colors<span class="goi-icon goi-pipette" v-if="json.setup.show_icons==true"></span>
											</label>
							 				<div class="color_selector" aria-hidden="true">
							 					<button type="button" class="convar black wahout" data-bgcolor="#000" data-color="#FFF" title="black background color" aria-label="black background color" tabindex="0"><span class="wahpro-active-contrast-property" style="background-color: rgb(0, 0, 0) !important; font-size: 14px;" data-wahfont="14"></span></button>
							 					<button type="button" class="convar white wahout" data-bgcolor="#FFF" data-color="#000" title="white background color" aria-label="white background color" tabindex="0"><span class="wahpro-active-contrast-property" style="background-color: rgb(255, 255, 255) !important; font-size: 14px;" data-wahfont="14"></span></button>
							 					<button type="button" class="convar green wahout" data-bgcolor="#00FF21" data-color="#000" title="green background color" aria-label="green background color" tabindex="0"><span class="wahpro-active-contrast-property" style="background-color: rgb(0, 128, 0) !important; font-size: 14px;" data-wahfont="14"></span></button>
							 					<button type="button" class="convar blue wahout" data-bgcolor="#00f" data-color="#FFD800" title="blue background color" aria-label="blue background color" tabindex="0"><span class="wahpro-active-contrast-property" style="background-color: rgb(0, 0, 255) !important; font-size: 14px;" data-wahfont="14"></span></button>
							 					<button type="button" class="convar red wahout" data-bgcolor="#F00" data-color="#000" title="red background color" aria-label="red background color" tabindex="0"><span class="wahpro-active-contrast-property" style="background-color: rgb(255, 0, 0) !important; font-size: 14px;" data-wahfont="14"></span></button>
							 					<button type="button" class="convar orange wahout" data-bgcolor="#FF6A00" data-color="#000" title="orange background color" aria-label="orange background color" tabindex="0"><span class="wahpro-active-contrast-property" style="background-color: rgb(255, 106, 0) !important; font-size: 14px;" data-wahfont="14"></span></button>
							 					<button type="button" class="convar yellow wahout" data-bgcolor="#FFD800" data-color="#000" title="yellow background color" aria-label="yellow background color" tabindex="0"><span class="wahpro-active-contrast-property" style="background-color: rgb(255, 216, 0) !important; font-size: 14px;" data-wahfont="14"></span></button>
							 					<button type="button" class="convar navi wahout" data-bgcolor="#B200FF" data-color="#000" title="navi background color" aria-label="navi background color" tabindex="0"><span class="wahpro-active-contrast-property" style="background-color: rgb(178, 0, 255) !important; font-size: 14px;" data-wahfont="14"></span></button>
							 				</div>
							 			</div>
 									</div>
								</div>

								<div class="wahpro-modern-title-colors-settings">
									<div class="a_module wah_titles_colors_trigger">
										<div class="a_module_exe titles_colors_module_exe">
											<label tabindex="-1" data-widgetid="widget-4" type="button" id="titles_colors_trigger" class="wahout wah-call-titles_colors" title="Contrast">
												Adjust Title Colors title<span class="goi-icon goi-color" v-if="json.setup.show_icons==true"></span>
											</label>
											<div class="titles_color_selector" aria-hidden="true">
												<button type="button" id="tci-1" class="title-color-trigger white wahout" data-color="#FFFFFF" title="Change color to white" aria-label="Change color to white" tabindex="0"><span style="background-color: rgb(255, 255, 255) !important; font-size: 21px;" data-wahfont="21"></span><span class="indicator" data-wahfont="21" style="font-size: 21px;"></span></button>
												<button type="button" id="tci-2" class="title-color-trigger black wahout" data-color="#000000" title="Change color to black" aria-label="Change color to black" tabindex="0"><span style="background-color: rgb(0, 0, 0) !important; font-size: 21px;" data-wahfont="21"></span><span class="indicator" data-wahfont="21" style="font-size: 21px;"></span></button>
												<button type="button" id="tci-3" class="title-color-trigger green wahout" data-color="#008000" title="Change color to green" aria-label="Change color to green" tabindex="0"><span style="background-color: rgb(0, 128, 0) !important; font-size: 21px;" data-wahfont="21"></span><span class="indicator" data-wahfont="21" style="font-size: 21px;"></span></button>
												<button type="button" id="tci-4" class="title-color-trigger blue wahout" data-color="#0000FF" title="Change color to blue" aria-label="Change color to blue" tabindex="0"><span style="background-color: rgb(0, 0, 255) !important; font-size: 21px;" data-wahfont="21"></span><span class="indicator" data-wahfont="21" style="font-size: 21px;"></span></button>
												<button type="button" id="tci-5" class="title-color-trigger red wahout" data-color="#FF0000" title="Change color to red" aria-label="Change color to red" tabindex="0"><span style="background-color: rgb(255, 0, 0) !important; font-size: 21px;" data-wahfont="21"></span><span class="indicator" data-wahfont="21" style="font-size: 21px;"></span></button>
												<button type="button" id="tci-6" class="title-color-trigger orange wahout" data-color="#FFA500" title="Change color to orange" aria-label="Change color to orange" tabindex="0"><span style="background-color: rgb(255, 165, 0) !important; font-size: 21px;" data-wahfont="21"></span><span class="indicator" data-wahfont="21" style="font-size: 21px;"></span></button>
												<button type="button" id="tci-7" class="title-color-trigger teal wahout" data-color="#008080" title="Change color to teal" aria-label="Change color to teal" tabindex="0"><span style="background-color: rgb(0, 128, 128) !important; font-size: 21px;" data-wahfont="21"></span><span class="indicator" data-wahfont="21" style="font-size: 21px;"></span></button>
												<button type="button" id="tci-8" class="title-color-trigger Yellow wahout" data-color="#FFFF00" title="Change color to Yellow" aria-label="Change color to Yellow" tabindex="0"><span style="background-color: rgb(255, 255, 0) !important; font-size: 21px;" data-wahfont="21"></span><span class="indicator" data-wahfont="21" style="font-size: 21px;"></span></button>
												<button type="button" id="tci-9" class="title-color-trigger Aquamarine wahout" data-color="#7FFFD4" title="Change color to Aquamarine" aria-label="Change color to Aquamarine" tabindex="0"><span style="background-color: rgb(127, 255, 212) !important; font-size: 21px;" data-wahfont="21"></span><span class="indicator" data-wahfont="21" style="font-size: 21px;"></span></button>
												<button type="button" id="tci-10" class="title-color-trigger Lime wahout" data-color="#00FF00" title="Change color to Lime" aria-label="Change color to Lime" tabindex="0"><span style="background-color: rgb(0, 255, 0) !important; font-size: 21px;" data-wahfont="21"></span><span class="indicator" data-wahfont="21" style="font-size: 21px;"></span></button>
											</div>
										</div>
									</div>
								</div>

								<div class="wahpro-modern-text-colors-settings">
									<div class="a_module wah_text_colors_trigger">
								 		<div class="a_module_exe text_colors_module_exe">
								 			<label tabindex="-1" data-widgetid="widget-text-colors" type="button" id="titles_colors_trigger" class="wahout wah-call-text_colors" aria-label="Adjust Text Colors title">
												Adjust Text Colors title<span class="goi-icon goi-color" v-if="json.setup.show_icons==true"></span>
								 			</label>
								 			<div class="text_color_selector" aria-hidden="true">
											<button type="button" id="txtci-1" class="title-color-trigger white wahout" data-color="#FFFFFF" title="Change text color to white" aria-label="Change text color to white" tabindex="0"><span style="background-color: rgb(255, 255, 255) !important; font-size: 21px;" data-wahfont="21"></span><span class="indicator" data-wahfont="21" style="font-size: 21px;"></span></button>
											<button type="button" id="txtci-2" class="title-color-trigger black wahout" data-color="#000000" title="Change text color to black" aria-label="Change text color to black" tabindex="0"><span style="background-color: rgb(0, 0, 0) !important; font-size: 21px;" data-wahfont="21"></span><span class="indicator" data-wahfont="21" style="font-size: 21px;"></span></button>
											<button type="button" id="txtci-3" class="title-color-trigger green wahout" data-color="#008000" title="Change text color to green" aria-label="Change text color to green" tabindex="0"><span style="background-color: rgb(0, 128, 0) !important; font-size: 21px;" data-wahfont="21"></span><span class="indicator" data-wahfont="21" style="font-size: 21px;"></span></button>
											<button type="button" id="txtci-4" class="title-color-trigger blue wahout" data-color="#0000FF" title="Change text color to blue" aria-label="Change text color to blue" tabindex="0"><span style="background-color: rgb(0, 0, 255) !important; font-size: 21px;" data-wahfont="21"></span><span class="indicator" data-wahfont="21" style="font-size: 21px;"></span></button>
											<button type="button" id="txtci-5" class="title-color-trigger red wahout" data-color="#FF0000" title="Change text color to red" aria-label="Change text color to red" tabindex="0"><span style="background-color: rgb(255, 0, 0) !important; font-size: 21px;" data-wahfont="21"></span><span class="indicator" data-wahfont="21" style="font-size: 21px;"></span></button>
											<button type="button" id="txtci-6" class="title-color-trigger orange wahout" data-color="#FFA500" title="Change text color to orange" aria-label="Change text color to orange" tabindex="0"><span style="background-color: rgb(255, 165, 0) !important; font-size: 21px;" data-wahfont="21"></span><span class="indicator" data-wahfont="21" style="font-size: 21px;"></span></button>
											<button type="button" id="txtci-7" class="title-color-trigger teal wahout" data-color="#008080" title="Change text color to teal" aria-label="Change text color to teal" tabindex="0"><span style="background-color: rgb(0, 128, 128) !important; font-size: 21px;" data-wahfont="21"></span><span class="indicator" data-wahfont="21" style="font-size: 21px;"></span></button>
											<button type="button" id="txtci-8" class="title-color-trigger Yellow wahout" data-color="#FFFF00" title="Change text color to yellow" aria-label="Change text color to yellow" tabindex="0"><span style="background-color: rgb(255, 255, 0) !important; font-size: 21px;" data-wahfont="21"></span><span class="indicator" data-wahfont="21" style="font-size: 21px;"></span></button>
											<button type="button" id="txtci-9" class="title-color-trigger Aquamarine wahout" data-color="#7FFFD4" title="Change text color to aquamarine" aria-label="Change text color to aquamarine" tabindex="0"><span style="background-color: rgb(127, 255, 212) !important; font-size: 21px;" data-wahfont="21"></span><span class="indicator" data-wahfont="21" style="font-size: 21px;"></span></button>
											<button type="button" id="txtci-10" class="title-color-trigger Lime wahout" data-color="#00FF00" title="Change text color to lime" aria-label="Change text color to lime" tabindex="0"><span style="background-color: rgb(0, 255, 0) !important; font-size: 21px;" data-wahfont="21"></span><span class="indicator" data-wahfont="21" style="font-size: 21px;"></span></button>
								 			</div>
								 		</div>
								 	</div>
								</div>

								<div class="wahpro-modern-link-colors-settings">
									<div class="a_module wah_link_colors_trigger">
								 		<div class="a_module_exe link_colors_module_exe">
								 			<label tabindex="-1" data-widgetid="widget-text-colors" type="button" id="links_colors_trigger" class="wahout wah-call-link_colors">
												Adjust Link Colors<span class="goi-icon goi-color" v-if="json.setup.show_icons==true"></span>
								 			</label>
								 			<div class="link_color_selector" aria-hidden="true">
												<button type="button" id="linkci-1" class="link-color-trigger white wahout" data-color="#FFFFFF" title="Change link color to white" aria-label="Change link color to white" tabindex="0"><span style="background-color: rgb(255, 255, 255) !important; font-size: 21px;" data-wahfont="21"></span><span class="indicator" data-wahfont="21" style="font-size: 21px;"></span></button>
												<button type="button" id="linkci-2" class="link-color-trigger black wahout" data-color="#000000" title="Change link color to black" aria-label="Change link color to black" tabindex="0"><span style="background-color: rgb(0, 0, 0) !important; font-size: 21px;" data-wahfont="21"></span><span class="indicator" data-wahfont="21" style="font-size: 21px;"></span></button>
												<button type="button" id="linkci-3" class="link-color-trigger green wahout" data-color="#008000" title="Change link color to green" aria-label="Change link color to green" tabindex="0"><span style="background-color: rgb(0, 128, 0) !important; font-size: 21px;" data-wahfont="21"></span><span class="indicator" data-wahfont="21" style="font-size: 21px;"></span></button>
												<button type="button" id="linkci-4" class="link-color-trigger blue wahout" data-color="#0000FF" title="Change link color to blue" aria-label="Change link color to blue" tabindex="0"><span style="background-color: rgb(0, 0, 255) !important; font-size: 21px;" data-wahfont="21"></span><span class="indicator" data-wahfont="21" style="font-size: 21px;"></span></button>
												<button type="button" id="linkci-5" class="link-color-trigger red wahout" data-color="#FF0000" title="Change link color to red" aria-label="Change link color to red" tabindex="0"><span style="background-color: rgb(255, 0, 0) !important; font-size: 21px;" data-wahfont="21"></span><span class="indicator" data-wahfont="21" style="font-size: 21px;"></span></button>
												<button type="button" id="linkci-6" class="link-color-trigger orange wahout" data-color="#FFA500" title="Change link color to orange" aria-label="Change link color to orange" tabindex="0"><span style="background-color: rgb(255, 165, 0) !important; font-size: 21px;" data-wahfont="21"></span><span class="indicator" data-wahfont="21" style="font-size: 21px;"></span></button>
												<button type="button" id="linkci-7" class="link-color-trigger teal wahout" data-color="#008080" title="Change link color to teal" aria-label="Change link color to teal" tabindex="0"><span style="background-color: rgb(0, 128, 128) !important; font-size: 21px;" data-wahfont="21"></span><span class="indicator" data-wahfont="21" style="font-size: 21px;"></span></button>
												<button type="button" id="linkci-8" class="link-color-trigger Yellow wahout" data-color="#FFFF00" title="Change link color to yellow" aria-label="Change link color to yellow" tabindex="0"><span style="background-color: rgb(255, 255, 0) !important; font-size: 21px;" data-wahfont="21"></span><span class="indicator" data-wahfont="21" style="font-size: 21px;"></span></button>
												<button type="button" id="linkci-9" class="link-color-trigger Aquamarine wahout" data-color="#7FFFD4" title="Change link color to aquamarine" aria-label="Change link color to aquamarine" tabindex="0"><span style="background-color: rgb(127, 255, 212) !important; font-size: 21px;" data-wahfont="21"></span><span class="indicator" data-wahfont="21" style="font-size: 21px;"></span></button>
												<button type="button" id="linkci-10" class="link-color-trigger Lime wahout" data-color="#00FF00" title="Change link color to lime" aria-label="Change link color to lime" tabindex="0"><span style="background-color: rgb(0, 255, 0) !important; font-size: 21px;" data-wahfont="21"></span><span class="indicator" data-wahfont="21" style="font-size: 21px;"></span></button>
								 			</div>
								 		</div>
								 	</div>
								</div>

								<div class="wahpro-switches-wrapper">
									<div class="a_module wah_keyboard_navigation" data-module="widget-2">
										<div class="a_module_exe">
											<ol class="switches" data-wahfont="21" style="font-size: 21px;">
												<li class="wahout">
													<input type="checkbox" tabindex="-1" id="widget-2" name="widget-2">
													<label for="widget-2" data-widgetid="widget-2" class="wah-action-button wahout wah-call-keyboard-navigation is-wah-label" tabindex="0">
													  	<span class="wah-module-title">
															<span class="goi-keyboard" v-if="json.setup.show_icons==true"></span>
															Keyboard navigation<div class="wah-module-desciption">Keyboard navigation assistant</div>
														</span>
													  	<span class="wah-animate-checkbox" data-wahfont="18" style="font-size: 18px;"></span>
													</label>
												</li>
											</ol>
										</div>
									</div>
									<div class="a_module wah_underline_links" data-module="widget-5">
										<div class="a_module_exe">
											<ol class="switches" data-wahfont="21" style="font-size: 21px;">
												<li class="wahout">
													<input type="checkbox" tabindex="-1" id="widget-5" name="widget-5">
													<label for="widget-5" data-widgetid="widget-5" class="wah-action-button wahout wah-call-underline-links is-wah-label" tabindex="0">
													  	<span class="wah-module-title" data-wahfont="18" style="font-size: 18px;">
															<span class="goi-underline" v-if="json.setup.show_icons==true"></span>
															Underline links<div class="wah-module-desciption">Underline all links on this page</div></span>
													  	<span class="wah-animate-checkbox" data-wahfont="18" style="font-size: 18px;"></span>
													</label>
												</li>
											</ol>
										</div>
									</div>
									<div class="a_module wah_highlight_links" data-module="widget-6">
										<div class="a_module_exe">
											<ol class="switches" data-wahfont="21" style="font-size: 21px;">
												<li class="wahout">
													<input type="checkbox" tabindex="-1" id="widget-6" name="widget-6">
													<label for="widget-6" data-widgetid="widget-6" class="wah-action-button wahout wah-call-highlight-links is-wah-label" tabindex="0">
													  	<span class="wah-module-title" data-wahfont="18" style="font-size: 18px;">
															<span class="goi-luminous-bulb" v-if="json.setup.show_icons==true"></span>
															Highlight Links<div class="wah-module-desciption">Highlight all links on this page</div>
														</span>
													  <span class="wah-animate-checkbox" data-wahfont="18" style="font-size: 18px;"></span>
													</label>
												</li>
											</ol>
										</div>
									</div>
									<div class="a_module wah_greyscale" data-module="widget-8">
										<div class="a_module_exe">
											<ol class="switches" data-wahfont="21" style="font-size: 21px;">
												<li class="wahout">
													<input type="checkbox" tabindex="-1" id="widget-8" name="widget-8">
													<label for="widget-8" data-widgetid="widget-8" class="greyscale wah-action-button wahout wah-call-greyscale is-wah-label" tabindex="0">
													  	<span class="wah-module-title" data-wahfont="18" style="font-size: 18px;"><span class="goi-crossed-out-drop" v-if="json.setup.show_icons==true"></span>Images Greyscale<div class="wah-module-desciption">Greyscale images on this page</div></span>
														<span class="wah-animate-checkbox" data-wahfont="18" style="font-size: 18px;"></span>
													</label>
												</li>
											</ol>
										</div>
									</div>
									<div class="a_module wah_invert" data-module="widget-9">
										<div class="a_module_exe">
											<ol class="switches" data-wahfont="21" style="font-size: 21px;">
												<li class="wahout">
													<input type="checkbox" tabindex="-1" id="widget-9" name="widget-9">
													<label for="widget-9" data-widgetid="widget-9" class="wah-action-button wahout wah-call-invert is-wah-label" tabindex="0">
													  	<span class="wah-module-title" data-wahfont="18" style="font-size: 18px;"><span class="goi-half-a-drop" v-if="json.setup.show_icons==true"></span>Invert Colors<div class="wah-module-desciption">Invert colors on this page</div></span>
													  	<span class="wah-animate-checkbox" data-wahfont="18" style="font-size: 18px;"></span>
													</label>
												</li>
											</ol>
										</div>
									</div>
									<div class="a_module wah_remove_animations" data-module="widget-10">
										<div class="a_module_exe">
											<ol class="switches" data-wahfont="21" style="font-size: 21px;">
												<li class="wahout">
													<input type="checkbox" tabindex="-1" id="widget-10" name="widget-10">
													<label for="widget-10" data-widgetid="widget-10" class="wah-action-button wahout wah-call-remove-animations is-wah-label" tabindex="0">
													  	<span class="wah-module-title" data-wahfont="18" style="font-size: 18px;"><span class="goi-animation" v-if="json.setup.show_icons==true"></span>Remove Animations<div class="wah-module-desciption">Remove animations on this page</div></span>
													  <span class="wah-animate-checkbox" data-wahfont="18" style="font-size: 18px;"></span>
													</label>
												</li>
											</ol>
										</div>
									</div>
									<div class="a_module wah_remove_styles" data-module="widget-11">
										<div class="a_module_exe">
											<ol class="switches" data-wahfont="21" style="font-size: 21px;">
												<li class="wahout">
													<input type="checkbox" tabindex="-1" id="widget-11" name="widget-11">
													<label for="widget-11" data-widgetid="widget-11" class="wah-action-button wahout wah-call-remove-styles is-wah-label" tabindex="0">
													  	<span class="wah-module-title" data-wahfont="18" style="font-size: 18px;"><span class="goi-delete" v-if="json.setup.show_icons==true"></span>Remove styles<div class="wah-module-desciption">Remove styles on this page</div></span>
													  <span class="wah-animate-checkbox" data-wahfont="18" style="font-size: 18px;"></span>
													</label>
												</li>
											</ol>
										</div>
									</div>
									<div class="a_module wah_highlight_titles_setup" data-module="widget-13">
										<div class="a_module_exe">
											<ol class="switches" data-wahfont="21" style="font-size: 21px;">
												<li class="wahout">
													<input type="checkbox" tabindex="-1" id="widget-13" name="widget-13">
													<label for="widget-13" data-widgetid="widget-13" class="wah-action-button wahout wah-highlight-titles wah-call-highlight-titles is-wah-label" tabindex="0">
													  	<span class="wah-module-title" data-wahfont="18" style="font-size: 18px;"><span class="goi-bulb" v-if="json.setup.show_icons==true"></span>Highlight titles<div class="wah-module-desciption">Highlight all titles on this page</div></span>
													  <span class="wah-animate-checkbox" data-wahfont="18" style="font-size: 18px;"></span>
													</label>
												</li>
											</ol>
										</div>
									</div>
									<div class="a_module wah_image_alt_setup" data-module="widget-14">
										<div class="a_module_exe">
											<ol class="switches" data-wahfont="21" style="font-size: 21px;">
												<li class="wahout">
													<input type="checkbox" tabindex="-1" id="widget-14" name="widget-14">
													<label for="widget-14" data-widgetid="widget-14" class="wah-action-button wahout wah-image-alt wah-call-image-alt is-wah-label" tabindex="0">
													  	<span class="wah-module-title" data-wahfont="18" style="font-size: 18px;"><span class="goi-image" v-if="json.setup.show_icons==true"></span>Image description<div class="wah-module-desciption">Display image alt text on mouse over.</div></span>
													  <span class="wah-animate-checkbox" data-wahfont="18" style="font-size: 18px;"></span>
													</label>
												</li>
											</ol>
										</div>
									</div>
									<div class="a_module wah_large_cursor" data-module="widget-16">
										<div class="a_module_exe">
											<ol class="switches" data-wahfont="21" style="font-size: 21px;">
												<li class="wahout">
													<input type="checkbox" tabindex="-1" id="widget-16" name="widget-16">
													<label for="widget-16" data-widgetid="widget-16" class="wah-action-button wahout wah_large_cursor wah-call-large_cursor is-wah-label" tabindex="0">
													  	<span class="wah-module-title" data-wahfont="18" style="font-size: 18px;"><span class="goi-arrows" v-if="json.setup.show_icons==true"></span>Large cursor<div class="wah-module-desciption">Enable large cursor mode.</div></span>
													  <span class="wah-animate-checkbox" data-wahfont="18" style="font-size: 18px;"></span>
													</label>
												</li>
											</ol>
										</div>
									</div>
									<div class="a_module wah_enable_monochrome_mode" data-module="widget-17">
										<div class="a_module_exe">
											<ol class="switches" data-wahfont="21" style="font-size: 21px;">
												<li class="wahout">
													<input type="checkbox" tabindex="-1" id="widget-17" name="widget-17">
													<label for="widget-17" data-widgetid="widget-17" class="wah-action-button wahout wah_enable_monochrome_mode wah-call-monochrome_mode is-wah-label" tabindex="0">
													  	<span class="wah-module-title" data-wahfont="18" style="font-size: 18px;"><span class="goi-black-and-white" v-if="json.setup.show_icons==true"></span>Monochrome<div class="wah-module-desciption">Enable monochrome view.</div></span>
													  <span class="wah-animate-checkbox" data-wahfont="18" style="font-size: 18px;"></span>
													</label>
												</li>
											</ol>
										</div>
									</div>
									<div class="a_module wah_enable_sepia_mode" data-module="widget-18">
										<div class="a_module_exe">
											<ol class="switches" data-wahfont="21" style="font-size: 21px;">
												<li class="wahout">
													<input type="checkbox" tabindex="-1" id="widget-18" name="widget-18">
													<label for="widget-18" data-widgetid="widget-18" id="wah_enable_sepia_mode" class="wah-action-button wahout wah_enable_sepia_mode wah-call-sepia_mode is-wah-label" tabindex="0">
													  	<span class="wah-module-title" data-wahfont="18" style="font-size: 18px;"><span class="goi-b-w-drop" v-if="json.setup.show_icons==true"></span>Sepia<div class="wah-module-desciption">Enable sepia view.</div></span>
													  <span class="wah-animate-checkbox" data-wahfont="18" style="font-size: 18px;"></span>
													</label>
												</li>
											</ol>
										</div>
									</div>
									<div class="a_module wah_enable_inspector_mode" data-module="widget-19">
										<div class="a_module_exe">
											<ol class="switches" data-wahfont="21" style="font-size: 21px;">
												<li class="wahout">
													<input type="checkbox" tabindex="-1" id="widget-19" name="widget-19">
													<label for="widget-19" data-widgetid="widget-19" id="wah_enable_inspector_mode" class="wah-action-button wahout wah_enable_inspector_mode wah-call-inspector_mode is-wah-label" tabindex="0">
														<span class="wah-module-title" data-wahfont="18" style="font-size: 18px;"><span class="goi-corners-screen" v-if="json.setup.show_icons==true"></span>Inspector<div class="wah-module-desciption">Enable inspector mode.</div></span>
													  <span class="wah-animate-checkbox" data-wahfont="18" style="font-size: 18px;"></span>
													</label>
												</li>
											</ol>
										</div>
									</div>
									<div class="a_module wah_enable_letter_spacing_mode" data-module="widget-12">
										<div class="a_module_exe">
											<ol class="switches" data-wahfont="21" style="font-size: 21px;">
												<li class="wahout">
													<input type="checkbox" tabindex="-1" id="widget-21" name="widget-21">
													<label for="widget-21" data-widgetid="widget-21" id="wah_letter_spacing" class="wah-action-button wahout set-wah-letter_spacing is-wah-label" tabindex="0">
														<span class="wah-module-title" data-wahfont="18" style="font-size: 18px;"><span class="goi-columns" v-if="json.setup.show_icons==true"></span>Letter spacing<div class="wah-module-desciption">Enable letter spacing mode.</div></span>
													  <span class="wah-animate-checkbox" data-wahfont="18" style="font-size: 18px;"></span>
													</label>
												</li>
											</ol>
										</div>
									</div>
									<div class="a_module wah_enable_adhd_profile" data-module="widget-22">
										<div class="a_module_exe">
											<ol class="switches" data-wahfont="21" style="font-size: 21px;">
												<li class="wahout">
													<input type="checkbox" tabindex="-1" id="widget-22" name="widget-22">
													<label for="widget-22" data-widgetid="widget-22" id="wah_adhd_profile" class="wah-action-button wahout set-wah-adhd_profile is-wah-label" tabindex="0">
														<span class="wah-module-title" data-wahfont="18" style="font-size: 18px;"><span class="goi-view-eye" v-if="json.setup.show_icons==true"></span>ADHD Profile<div class="wah-module-desciption">Set more focus on the content.</div></span>
													  <span class="wah-animate-checkbox" data-wahfont="18" style="font-size: 18px;"></span>
													</label>
												</li>
											</ol>
										</div>
									</div>
									<div class="a_module wah_enable_mute" data-module="widget-24">
										<div class="a_module_exe">
											<ol class="switches" data-wahfont="21" style="font-size: 21px;">
												<li class="wahout">
													<input type="checkbox" tabindex="-1" id="widget-24" name="widget-24">
													<label for="widget-24" data-widgetid="widget-24" id="wah_enable_mute" class="wah-action-button wahout set-wah-mute is-wah-label" tabindex="0">
														<span class="wah-module-title" data-wahfont="18" style="font-size: 18px;"><span class="goi-sound-icon goi-sound-full" v-if="json.setup.show_icons==true"></span>Mute volume<div class="wah-module-desciption">Mute all sounds.</div></span>
													  <span class="wah-animate-checkbox" data-wahfont="18" style="font-size: 18px;"></span>
													</label>
												</li>
											</ol>
										</div>
									</div>
									<div class="a_module wah_enable_hide_images" data-module="widget-25">
										<div class="a_module_exe">
											<ol class="switches" data-wahfont="21" style="font-size: 21px;">
												<li class="wahout">
													<input type="checkbox" tabindex="-1" id="widget-25" name="widget-25">
													<label for="widget-25" data-widgetid="widget-25" id="wah_enable_mute" class="wah-action-button wahout set-wah-hide-images is-wah-label" tabindex="0">
														<span class="wah-module-title" data-wahfont="18" style="font-size: 18px;"><span class="goi-image" v-if="json.setup.show_icons==true"></span>Hide images<div class="wah-module-desciption">Hide all images.</div></span>
													  <span class="wah-animate-checkbox" data-wahfont="18" style="font-size: 18px;"></span>
													</label>
												</li>
											</ol>
										</div>
									</div>
								</div>

							</div>

						</div>

					</aside>

				</div>
            </div>

        </div>

        <div class="advanced-settings-container" v-if="this.free_mode == false">
            <div class="form-row">
                <h3>
                    <span>{{ locale[current_lang].advanced_translation_settings }}:
                        <i :class="{ 'on' : advancedStatus, 'off' : ! advancedStatus }"></i>
                    </span>
                </h3>

                <label class="inline">
                    <input type="checkbox" v-model="advancedSettings" @change="updateAdvancedSettings()">
                    <span class="span-title">{{ locale[current_lang].enable_label }}</span>
                </label>

                <transition name="slide" >
                    <div class="toggle-advanced-wrapper" v-if="advancedSettings">
                        <div class="adv-row">
                            <label>
                                <span>{{ locale[current_lang].advanced_labels.close_button }}:</span>
                                <input type="text" v-model="advanced.close">
                            </label>
                            <label>
                                <span>{{ locale[current_lang].advanced_labels.font_resize }}:</span>
                                <input type="text" v-model="advanced.font_resize">
                            </label>
                            <label>
                                <span>{{ locale[current_lang].advanced_labels.font_size }}:</span>
                                <input type="text" v-model="advanced.font_resize_sign">
                            </label>
                            <label>
                                <span>{{ locale[current_lang].advanced_labels.reset_font_size }}:</span>
                                <input type="text" v-model="advanced.reset_font_size">
                            </label>
                            <label>
                                <span>{{ locale[current_lang].advanced_labels.keyboard_navigation }}:</span>
                                <input type="text" v-model="advanced.keyboard_navigation">
                            </label>
                            <label>
                                <span>{{ locale[current_lang].advanced_labels.readable_font }}:</span>
                                <input type="text" v-model="advanced.readable_font">
                            </label>
                            <label>
                                <span>{{ locale[current_lang].advanced_labels.contrast }}:</span>
                                <input type="text" v-model="advanced.contrast">
                            </label>
                            <label>
                                <span>{{ locale[current_lang].advanced_labels.choose_color }}:</span>
                                <input type="text" v-model="advanced.choose_color">
                            </label>
                            <label>
                                <span>{{ locale[current_lang].advanced_labels.highlight_links }}:</span>
                                <input type="text" v-model="advanced.highlight_links">
                            </label>
                            <label>
                                <span>{{ locale[current_lang].advanced_labels.highlight_titles }}:</span>
                                <input type="text" v-model="advanced.highlight_titles">
                            </label>
                            <label>
                                <span>{{ locale[current_lang].advanced_labels.clear_cookies }}:</span>
                                <input type="text" v-model="advanced.clear_cookies">
                            </label>
                            <label>
                                <span>{{ locale[current_lang].advanced_labels.images_greyscale }}:</span>
                                <input type="text" v-model="advanced.images_greyscale">
                            </label>
                            <label>
                                <span>{{ locale[current_lang].advanced_labels.invert_colors }}:</span>
                                <input type="text" v-model="advanced.invert_colors">
                            </label>
                            <label>
                                <span>{{ locale[current_lang].advanced_labels.remove_animations }}:</span>
                                <input type="text" v-model="advanced.remove_animations">
                            </label>
                        </div>
                    </div>
                </transition>

            </div>
        </div>

        <div class="buider-preview builder-code" v-if="code">

            <div class="builder-step-2">
                <div class="step-header">
                    <span>{{ locale[current_lang].step2_title }}</span>
                </div>

                <textarea v-model="code" @click="selectCode()" ref="codeEditor"></textarea>
                <div class="notice-wrapper" v-if="code">
                    <div class="copied" v-if="copied">
                        {{ locale[current_lang].notice_copied }}
                    </div>
                </div>
            </div>

            <div class="builder-step-3">
                <div class="step-header">
                    <span>{{ locale[current_lang].step3_title }}</span>
                </div>

                <div class="step-description step3-description">
                    <p v-html="locale[current_lang].step3_description"></p>
                    <div class="code-editor" contenteditable="true">
                        <p v-html="step3_scripts_jquery" v-if="!json.setup.jquery"></p>
                        <p v-html="locale[current_lang].step3_script_config"></p>
                        <p>&lt;script src="https://accessibility-helper.co.il/remote/wahpro?uid={{uid}}" charset="utf-8"&gt;&lt;/script&gt;</p>
                    </div>
                    <div class="notice" v-if="!uid">
                        {{ locale[current_lang].error_id_label }}
                    </div>
                </div>
            </div>

        </div>

    </div>

</template>

<script>

export default {
    name: 'hello',
    data () {
        return {
            uid                     : '',
            free_mode               : false,
            code                    : '',
            copied                  : false,
            current_lang            : 'en',
            current_live_lang       : 'en',
            is_rtl                  : false,
            defaultLivePreviewBG    : 'black',
            defaultLivePreviewColor : 'white',
            step3_scripts_jquery    : '&lt;script src="https://code.jquery.com/jquery-1.12.4.min.js"&gt;',
            advancedStatus          : false,
            advancedSettings        : false,     // custom translations
            locale : {
                en : {
                    mobile                       : 'Hide for mobile?',
                    lorem_ipsum                  : '<h1>Lorem title</h1><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>',
                    step1_title                  : 'Step 1 - Generate script code',
                    step2_title                  : 'Step 2 - Copy code',
                    step3_title                  : 'Step 3 - Insert code template into your page',
                    step3_script_config          : '&lt;script&gt;&lt;!-- Paste your code from step 2 HERE --&gt;&lt;/script&gt;',
                    step3_description            : '<p><strong>Paste the code just right before closing body tag &lt;/body&gt;.</p><p>jQuery library is required! So if you do not have it, please include it before calling WAH PRO script.</strong></p><p><strong>Please, double check your User ID, if User ID is not valid - WAH PRO remote script will NOT work.</strong></p><p>The example of result code:</p>',
                    title                        : 'Welcome to WAH PRO Remote script Builder',
                    subtitle                     : 'WP Accessibility Helper by WAH TEAM',
                    user_settings                : 'User settings',
                    user_id                      : 'License key (required)',
                    theme_settings               : 'Theme Settings',
                    theme_name                   : 'Theme color',
                    layout                       : 'Layout',
                    sidebar_position             : 'Sidebar position',
                    setup_settings               : 'Setup Settings',
                    language                     : 'Plugin Language',
                    enable_debug                 : 'Enable debug?',
                    enable_statistics            : 'Enable statistics?',
					show_icons_label 			 : 'Show icons',
					show_statement_label 		 : 'Show Accessibility Statement',
                    disable_remove_animations    : 'Disable "Remove animations" button?',
                    disable_highlight_titles     : 'Disable "Highlight titles" button?',
                    disable_highlight_links      : 'Disable "Highlight links" button?',
                    disable_keyboard_navigations : 'Disable "Keyboard navigation" button?',
                    disable_invert_colors        : 'Disable "Invert colors" button?',
                    disable_readable_fonts       : 'Disable "Readable fonts" button?',
                    english_label                : 'English',
                    russian_label                : 'Russian',
                    hebrew_label                 : 'Hebrew',
                    right_label                  : 'Right',
                    left_label                   : 'Left',
                    standart_label               : 'Standart (1 columns)',
                    wide_label                   : 'Wide (2 columns)',
                    magic_label                  : 'Magic (animation effect)',
					modern_label                 : 'Modern layout',
                    dark_label                   : 'Dark',
                    light_label                  : 'Light',
                    error_id_label               : 'Important notice: User ID is required.',
                    notice_copied                : 'Code has been copied!',
                    live_preview_title           : 'Live preview',
                    jquery                       : 'I have <a href="https://jquery.com" target="_blank"><strong>jQuery</strong></a> installed on my website',
                    live : {
                        close               : 'Close',
						statement           : 'Statement',
                        font_resize         : 'Font Resize',
                        reset_font_size     : 'Rest font size',
                        keyboard_navigation : 'Keyboard navigation',
                        readable_font       : 'Readable font',
                        contrast            : 'Contrast',
                        choose_color        : 'Choose color',
                        highlight_links     : 'Highlight links',
                        highlight_titles    : 'Highlight titles',
                        clear_cookies       : 'Reset',
                        images_greyscale    : 'Images greyscale',
                        invert_colors       : 'Invert colors',
                        remove_animations   : 'Remove animations'
                    },
                    advanced_translation_settings : 'Advanced Translation Settings',
                    enable_label : 'Enable',
                    advanced_labels : {
                        close_button : 'Close button label',
                        font_resize : 'Font resize label',
                        font_size : 'Font sign (A+/A-) label',
                        reset_font_size : 'Reset font size label',
                        keyboard_navigation : 'Keyboard navigation label',
                        readable_font : 'Readable font label',
                        contrast : 'Contrast label',
                        choose_color : 'Choose color label',
                        highlight_links : 'Highlight links label',
                        highlight_titles : 'Highlight titles label',
                        clear_cookies : 'Clear cookies label',
                        images_greyscale : 'Images greyscale label',
                        invert_colors : 'Invert colors label',
                        remove_animations: 'Remove animations label'
                    }
                },
                ru : {
                    mobile                       : 'Спрятать на мобильных устройствах?',
                    lorem_ipsum                  : '<h1>Лорем ипсум заголовок</h1><p>Лорем ипсум долор сит амет, ут сит суас граецис трацтатос, ид дицта сонет модератиус сеа, ерос импедит хас ид. Реяуе тантас ментитум но про, еум ид воцент плацерат цонсеяуат. Нам ессе волутпат петентиум ут. Юсто нихил цонституам ан сед. Не цонвенире интерессет вел, дисцере алияуид феугаит при ид.</p>',
                    step1_title                  : 'Шаг 1 - Заполнить форму и получить код.',
                    step2_title                  : 'Шаг 2 - Скопировать код',
                    step3_title                  : 'Шаг 3 - Вставить код на вашу страничку',
                    step3_script_config          : '&lt;script&gt;&lt;!-- Вставьте код полученный в шаге 2 сюда --&gt;&lt;/script&gt;',
                    step3_description            : '<p>Вставить данный код перед закрытием тэга body</p><p>Библиотека jQuery должна быть добавлена на вашу страничку! В случае отсутсвия данной библиотеки скрипт работать не будет.</strong></p><p>Ваш скрипт должен выглядеть следующим образом:</p><p><strong>Пожалуйста, перепроверьте дважды ваш User ID, в противной случае скрипт работать не будет.</strong></p>',
                    title                        : 'Добро пожаловать в WAH PRO Remote script Builder',
                    subtitle                     : 'WP Accessibility Helper by WAH TEAM',
                    user_settings                : 'Настройки пользователя',
                    user_id                      : 'ID пользователя (обязательно)',
                    theme_settings               : 'Настройки шаблона',
                    theme_name                   : 'Цвет шаблона',
                    layout                       : 'Структура шаблона',
                    sidebar_position             : 'Позиция',
                    setup_settings               : 'Настройки',
                    language                     : 'Язык',
                    enable_debug                 : 'Включить debug?',
                    enable_statistics            : 'Включить статистику?',
					show_icons_label 			 : 'Показать значки',
					show_statement_label 		 : 'Показать заявление о доступности',
                    disable_remove_animations    : 'Отключить кнопку "Отключение анимации"?',
                    disable_highlight_titles     : 'Отключить кнопку "Подсветка заголоков"?',
                    disable_highlight_links      : 'Отключить кнопку "Подсветка ссылок"?',
                    disable_keyboard_navigations : 'Отключить кнопку "Навигации с клавиатуры"?',
                    disable_invert_colors        : 'Отключить кнопку "Искажение цвета"?',
                    disable_readable_fonts       : 'Отключить кнопку "Читаемый шрифт"?',
                    english_label                : 'Английский (США и Великобритания)',
                    russian_label                : 'Русский (Россия)',
                    hebrew_label                 : 'Иврит (Израиль)',
                    right_label                  : 'Справа',
                    left_label                   : 'Слева',
                    standart_label               : 'Стандартный (1 колонка)',
                    wide_label                   : 'Широкий (2 колонки)',
                    magic_label                  : 'Волшебный (с эффектом анимации)',
                    dark_label                   : 'Тёмный',
                    light_label                  : 'Светлый',
                    error_id_label               : 'Внимание! "User ID" это обязательный параметр. Без него ваш скрипт работать НЕ будет.',
                    notice_copied                : 'Код скопирован в буфер обмена!',
                    live_preview_title           : 'Предпросмотр',
                    jquery                       : '<a href="https://jquery.com" target="_blank"><strong>jQuery</strong></a> уже установлен на моем сайте',
                    live : {
                        close               : 'Закрыть',
						statement           : 'заявление',
                        font_resize         : 'Размер шрифта',
                        reset_font_size     : 'Сбросить размер',
                        keyboard_navigation : 'Навигация с клавиатуры',
                        readable_font       : 'Стандартный шрифт',
                        contrast            : 'Контраст',
                        choose_color        : 'Выбрать цвет',
                        highlight_links     : 'Подсветить ссылки',
                        highlight_titles    : 'Подсветить заголовки',
                        clear_cookies       : 'Сбросить',
                        images_greyscale    : 'Серый оттенок',
                        invert_colors       : 'Инвертировать цвета',
                        remove_animations   : 'Отключить анимацию'
                    },
                    advanced_translation_settings : 'Настройки перевода',
                    enable_label : 'Включить',
                    advanced_labels : {
                        close_button : 'Закрыть - метка',
                        font_resize : 'Размер фонта - метка',
                        font_size : 'Символ размера фонта (A+/A-) - метка',
                        reset_font_size : 'Сбросить размер фонта - метка',
                        keyboard_navigation : 'Навигация с клавиатуры - метка',
                        readable_font : 'Стандартный фонт - метка',
                        contrast : 'Контраст - метка',
                        choose_color : 'Выбрать цвет - метка',
                        highlight_links : 'Подсветить ссылки - метка',
                        highlight_titles : 'Подсветить заголовки - метка',
                        clear_cookies : 'Сбросить настройки - метка',
                        images_greyscale : 'Серые картинки - метка',
                        invert_colors : 'Инвертировать цвета - метка',
                        remove_animations: 'Отключить анимацию - метка'
                    }
                },
                he : {
                    mobile                       : 'הסתר לניידים?',
                    lorem_ipsum                  : '<h1>לורם איפסום כותרת</h1><p>לורם איפסום דולור סיט אמט, קונסקטורר אדיפיסינג אלית קוואזי במר מודוף. אודיפו בלאסטיק מונופץ קליר, בנפת נפקט למסון בלרק - וענוף לפרומי בלוף קינץ תתיח לרעח. לת צשחמי צש בליא, מנסוטו צמלח לביקו ננבי, צמוקו בלוקריה שיצמה ברורק.</p>',
                    step1_title                  : 'שלב 1 - למלא טופס ולקבל קוד התמאה.',
                    step2_title                  : 'שלב 2 - להעתיק קוד',
                    step3_title                  : 'שלב 3 - להדביר קוד לעמוד',
                    step3_script_config          : '&lt;script&gt;&lt;!-- הדביקו קוד שקיבלתם בשלב 2 לכא --&gt;&lt;/script&gt;',
                    step3_description            : '<p>תדביקו קוד שקבלתם ישר אחרי סגירה של תגית body.</p><p><strong>חייבים להוסיף ספריית jQuery לעמוד שלכם, אחרת הסקריפט לא יעבוד!</strong></p><p>קוד שלכם אמור להראות בצורה בהא:</p><p><strong>בבקשה, תבדקו פעמים את User ID שלכם, אחרת סקריפט לא יעבוד.</strong></p>',
                    title                        : 'ברוכים הבאים ל WAH PRO Remote script Builder',
                    subtitle                     : 'WP Accessibility Helper by WAH TEAM',
                    user_settings                : 'הגדרות משתמש',
                    user_id                      : 'מזהה של משתמש (שדה חובה)',
                    theme_settings               : 'הגדרות תבנית',
                    theme_name                   : 'צבע של תבנית',
                    layout                       : 'פריסת תבנית',
                    sidebar_position             : 'מיקום של סרגל צד',
                    setup_settings               : 'הדגרות',
                    language                     : 'שפה',
                    enable_debug                 : 'הפעל איתור שגיות?',
                    enable_statistics            : 'הפעל סטטיסטיקה?',
					show_icons_label 			 : 'הצג אייקונים',
					show_statement_label 		 : 'הצג הצהרת נגישות',
                    disable_remove_animations    : 'הסר כפתור "הסר אנימציות"?',
                    disable_highlight_titles     : 'הסר כפתור "סימון כותרות"?',
                    disable_highlight_links      : 'הסר כפתור "סימון קישורים"?',
                    disable_keyboard_navigations : 'הסר כפתור "ניווט מקלדת"?',
                    disable_invert_colors        : 'הסר כפתור "היפוך צבעים"?',
                    disable_readable_fonts       : 'הסר כפתור "פונט קריא"?',
                    english_label                : 'אנגלית',
                    russian_label                : 'רוסית',
                    hebrew_label                 : 'עברית',
                    right_label                  : 'צד ימין',
                    left_label                   : 'צד שמאל',
                    standart_label               : 'רגיל (עמודה 1)',
                    wide_label                   : 'רחב (2 עמודות)',
                    magic_label                  : 'מגיק (אפקט אנימציה)',
                    dark_label                   : 'כהה',
                    light_label                  : 'בהיר',
                    error_id_label               : 'שימו לב! מזהה של משתמש הוא שדה חובה. ללא מזהה תקין קוד לא יעבוד.',
                    notice_copied                : 'קוד הועתק בהצלחה!',
                    live_preview_title           : 'תצוגה מקדימה',
                    jquery                       : '<a href="https://jquery.com" target="_blank"><strong>jQuery</strong></a> כבר מותקן באתר',
                    live : {
                        close               : 'סגור',
						statement           : 'הצהרה',
                        font_resize         : 'גודל פונט',
                        reset_font_size     : 'אפס גודל פונט',
                        keyboard_navigation : 'ניווט מקלדת',
                        readable_font       : 'פונט קריא',
                        contrast            : 'ניגודיות',
                        choose_color        : 'בחר צבע',
                        highlight_links     : 'סימון קישורים',
                        highlight_titles    : 'סינון כותרות',
                        clear_cookies       : 'איפוס',
                        images_greyscale    : 'תמונות אפורות',
                        invert_colors       : 'היפוך צבעים',
                        remove_animations   : 'הסר אנימציה'
                    },
                    advanced_translation_settings : 'הגדרות תרגום',
                    enable_label : 'הפעל',
                    advanced_labels : {
                        close_button : 'סגור - תגית',
                        font_resize : 'גודל פונט - תגית',
                        font_size : 'סימן גודל פונט (A+/A-) - תגית',
                        reset_font_size : 'איפוס גודל פונט - תגית',
                        keyboard_navigation : 'ניווט מקלדת - תגית',
                        readable_font : 'פונט קריא - תגית',
                        contrast : 'ניגודיות - תגית',
                        choose_color : 'בחר צבע - תגית',
                        highlight_links : 'סימון קישורים - תגית',
                        highlight_titles : 'סימון כותרות - תגית',
                        clear_cookies : 'איפוס - תגית',
                        images_greyscale : 'תמונות אפורות - תגית',
                        invert_colors : 'היפוך צבעים - תגית',
                        remove_animations: 'הסר אנימציות - תגית'
                    }
                }
            },
            json: {
                theme: {
                    name     : 'dark',           // dark || light
                    position : 'right',          // right || left
                    type     : 4,                // 1 = standart, 2 = wide, 3 = magic, 4 = modern
                },
                setup: {
                    debug    : true,              // true or false
                    stats    : true,              // true or false
                    lang     : 'en',              // en, ru, he [default en]
                    jquery   : false,             // true or false,
                    mobile   : true,
					show_icons : false,
					show_statement : false,
                    hide : {
                        remove_animations   : false,
                        highlight_titles    : false,
                        highlight_links     : false,
                        keyboard_navigation : false,
                        invert_colors       : false,
                        readable_fonts      : false,
                        contrast            : false
                    }
                }
            },
            advanced : {
                close               : 'Close',
                font_resize         : 'Font Resize',
                font_resize_sign    : 'A',
                reset_font_size     : 'Rest font size',
                keyboard_navigation : 'Keyboard navigation',
                readable_font       : 'Readable font',
                contrast            : 'Contrast',
                choose_color        : 'Choose color',
                highlight_links     : 'Highlight links',
                highlight_titles    : 'Highlight titles',
                clear_cookies       : 'Clear cookies',
                images_greyscale    : 'Images greyscale',
                invert_colors       : 'Invert colors',
                remove_animations   : 'Remove animations'
            }
        }
    },
    methods: {
        updateAdvancedSettings(){

            this.advancedStatus = ! this.advancedStatus;

            if( this.advancedSettings ){
                this.json.setup.translations = this.advanced;
            } else {
                delete this.json.setup.translations;
            }

            this.generateCode();
        },
        generateCode(){
            var str_start = 'var wahproConfig = ';
            var str = JSON.stringify( this.json, undefined, 4 );
            var str_end = ';';
            var str_result = str_start + str + str_end;
            this.code = str_result;
        },
        selectCode(){
            var textarea = this.$refs.codeEditor;
            textarea.select();
            document.execCommand("copy");
            this.copied = true;
            setTimeout( function(){
                this.copied = false;
            }.bind(this), 3000);
        },
        updateLocale(lang){
            this.is_rtl = ( lang == 'he' ) ? true : false;
            this.current_lang = lang;
        },
        updateLivePreviewLanguage(lang){
            this.current_live_lang = this.json.setup.lang;
        },
        switchLivePreviewBG(bg, color){
            this.defaultLivePreviewBG = bg;
            this.defaultLivePreviewColor = color;
        }
    },
    watch: {
        json: {
            handler: function (val, oldVal) {
                this.generateCode();
            },
            deep: true
        },
        advanced : {
            handler: function (val, oldVal) {
                this.generateCode();
            },
            deep: true
        }
    },
    mounted() {
        this.generateCode();
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Builder.vue